import { useDispatch } from "react-redux";
import showToast from "../../Hooks/toast";
import {setSendData} from "../../../Store/Slice/scheduleSlice";
import {useGetAffirmDueDaysMutation} from "../../../Store/Builder/schedule.api";

const useGetAffirmDueDaysApi = () => {
  const dispatch = useDispatch();
  const [getAffirmDays] = useGetAffirmDueDaysMutation();

  const get = () => {
    getAffirmDays()
      .unwrap()
      .then((res) => {
        dispatch(setSendData({affirm_due_days: res?.affirm_due_days}))
      })
      .catch((err) => {
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  return {
    get,
  };
};

export default useGetAffirmDueDaysApi;
